import replaceApiVersion from '~/utils/text/replaceApiVersion';
import { ICeDocument } from '~/services/api/communityEngagement/types';
import { IResource } from '~/services/api/resource/types';
import ResourceType from '~/ui/pages/Resources/models/ResourceType';

const typeByExtension: Record<string, ResourceType> = {
  pdf: ResourceType.Pdf,
  png: ResourceType.Image,
  jpg: ResourceType.Image,
  jpeg: ResourceType.Image,
  gif: ResourceType.Image,
  heic: ResourceType.Image,
  heif: ResourceType.Image,
  doc: ResourceType.Document,
  docx: ResourceType.Document,
  xls: ResourceType.Excel,
  xlsx: ResourceType.Excel,
  csv: ResourceType.Excel,
  ppt: ResourceType.Presentation,
  pptx: ResourceType.Presentation,
};

export const getTypeByFileName = (fileName: string): ResourceType => {
  const dot = fileName.lastIndexOf('.');
  if (dot === -1) return ResourceType.Text;
  return typeByExtension[fileName.slice(dot + 1).toLowerCase()] ?? ResourceType.Text;
};

export const splitFileName = (fileName: string): { name: string; extension: string } => {
  const dot = fileName.lastIndexOf('.');
  if (dot === -1) return { name: fileName, extension: '' };
  return { name: fileName.slice(0, dot), extension: fileName.slice(dot) };
};

type ICeFile = Pick<ICeDocument, 'fileId' | 'fileName'> &
  Partial<Pick<ICeDocument, 'id' | 'uploadedOn'>>;

const formatCeDocument = ({ id = 0, fileId, fileName, uploadedOn = '' }: ICeFile): IResource => ({
  id,
  name: fileName,
  externalUrl: `${replaceApiVersion(process.env.REACT_APP_API_URL, 'v1/')}File/${fileId}`,
  type: getTypeByFileName(fileName),
  isVisible: true,
  isArchived: false,
  modifiedOn: uploadedOn,
});

export default formatCeDocument;
